import clsx from 'clsx';
import { FC } from 'react';
import React from 'react';
import { styles } from '../styles';

interface Props {
    className?: string;
}

export const Menu: FC<Props> = ({ className, ...props }) => (
    <div className={clsx(styles.menu, className)} {...props} />
);
